export const TOGGLE = "TOGGLE";

export const USER_LOGIN = "user_login";
export const USER_LOGOUT = "user_logout";
export const CHECK_LOGING = "check_login";
